<template>
  <div class="gift-box">
    <div>
      <div class="search-box">
        <el-input
          size="small"
          style="width: 300px; margin-right: 10px"
          v-model.trim="searchForm.productName"
          clearable
          placeholder="产品名称"
          @keyup.13.native="onSearch"
        />
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
        <el-button size="small" @click="onReset">清空</el-button>
      </div>
    </div>
    <div class="tips-jump">
        如您没有找到合适的产品，请
        <el-button type="text" @click="goWishList">填写心愿单</el-button>
        ，提交您的心愿需求
        <i class="iconfont icon-aixin" style="color: #ab0033; font-size: 13px"></i>
    </div>
    <div class="search-type">
      <el-radio-group
        v-model="searchForm.firstCategory"
        @change="firstCategoryChange"
      >
        <el-radio-button v-for="item in firstCategoryList" :label="item.value" :key="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
      <el-radio-group
        v-model="searchForm.secondCategory"
        class="category-box"
        v-if="secondCategoryList.length > 1"
        @change="secondCategoryChange"
      >
        <el-radio v-for="item in secondCategoryList" :label="item.value" :key="item.value">
          {{ item.label }}
        </el-radio>
      </el-radio-group>
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHead"
      :tableData="tableData"
      :tableParam="tableParam"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
      @sort-change="sortChange"
    >
      <template #mainImage="{ row }">
        <el-image
          style="width: 50px; height: 50px;"
          :src="row.mainImage + $ImgQuality30"
          :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
      </template>
      <template #productName="{ row }">
        <el-button type="text" @click="getDetail(row)">{{ row.productName }}</el-button>
      </template>
    </CommonTable>
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';
import { FIRST_CATEGORY_TABLE_HEAD, SECOND_CATEGORY_TABLE_HEAD } from '@/utils/productTableHead';

export default {
  components: { CommonTable },
  props: {},
  data() {
    return {
      name: "GIFT",
      searchVal: '',
      searchForm: {
        productName: '',
        firstCategory: 'IT',
        secondCategory: '',
        statusList: ['PUT_ON']
      },
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        orderBy: ''
      },
      tableData: {},
      tableLoading: false,
      firstCategoryList: [],
      secondCategoryList: [],
      tableHead: []
    };
  },
  mounted() {
    this.$refs.CommonTable.changeHeight(124);
    this.firstCategoryChange('IT');
    this.firstCategoryList = this.$store.getters.allDictListData.data['cml_pd_first_category'].filter(item => item.value !== 'MATERIAL');
  },
  methods: {
    getDetail (row) {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: row.productName,
          href: `/own-manage/own-details-page?id=${row.id}&firstCategory=${row.firstCategory}`,
          isURLSearchParams: true
        },
      });
      this.$router.push({
        name: 'own-manage/own-details-page',
        query: {
          id: row.id,
          firstCategory: row.firstCategory
        },
      });
    },
    firstCategoryChange (val) {
      this.$http.pdLibrary.listByFirstCategory(val).then((res) => {
        this.searchForm.secondCategory = res.data[0].secondCategory;
        this.secondCategoryList = res.data.map(item => ({
          label: item.secondCategoryName,
          value: item.secondCategory
        }));
        this.getList();
      })
    },
    secondCategoryChange () {
      this.getList()
    },
    getList() {
      if (FIRST_CATEGORY_TABLE_HEAD[this.searchForm.firstCategory]) {
        this.tableHead = FIRST_CATEGORY_TABLE_HEAD[this.searchForm.firstCategory];
      } else {
        this.tableHead = SECOND_CATEGORY_TABLE_HEAD[this.searchForm.secondCategory];
      }
      this.$refs.CommonTable.refreshColumn();
      this.tableLoading = true;
      this.$http.pdLibrary.pdLibraryListPageMall({
        ...this.tableParam,
        data: this.searchForm
      }).then(result => {
        this.tableData = {
          ...result.data,
          list: result.data.list.map(item => ({
            ...item,
            hasCmaName: item.hasCma === 'YES' ? '是' : (item.hasCma === 'NO' ? '否' : ''),
            hasCnasName: item.hasCnas === 'YES' ? '是' : (item.hasCnas === 'NO' ? '否' : ''),
          }))
        };
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    sortChange(val) {
      this.tableParam.orderBy = val;
      this.getList();
    },
    onSearch() {
      this.tableParam.pageNo = 1;
      this.getList();
    },
    sortChangeList(name, val) {
      this.tableParam.orderBy = `${name} ${val}`;
      this.getList();
    },
    onReset() {
      this.searchForm.productName = '';
      this.getList();
    },
    goWishList () {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: '心愿单',
          href: '/own-manage/wish-list',
        },
      });
      this.$router.push({
        name: 'own-manage/wish-list'
      });
    }
  },
};
</script>

<style lang="less" scoped>
.tips-jump {
  font-size: 12px;
  font-weight: bold;
  margin-top: 5;
}
.search-box {
  display: inline-block;
  .el-button--text {
    color: #333;
    font-size: 16px;
    margin-left: 20px;
    &:hover {
      color: #AB0033;
    }
  }
  /deep/ .el-icon-shopping-cart-full {
    font-size: 24px;
    color: #AB0033;
  }
  span {
    padding-top: 8px;
    color: #AB0033;
  }
}
.gift-box {
  // max-width: 1170px;
  padding: 0 20px;
  margin: 0 auto;
}
/deep/ .sample-list {
  // max-width: 1170px;
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
  #tab-jg {
    padding-left: 10px !important;
  }
  #tab-rl {
    padding-right: 10px !important;
  }
}
.search-type {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  .category-box{
    display: block;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #ccc;
  }
}
/deep/ .el-radio__label {
  font-size: 12px !important;
}
</style>
